import React, { useLayoutEffect, useRef, useState } from 'react';
import { Swiper } from 'swiper/react';
import { Autoplay, Navigation, Scrollbar } from 'swiper/modules';

import ArrowLeft from '../../atoms/icons/ArrowLeft';
import ArrowRight from '../../atoms/icons/ArrowRight';
import ArrowLeftNarrow from '../../atoms/icons/ArrowLeftNarrow';
import ArrowRightNarrow from '../../atoms/icons/ArrowRightNarrow';
import SliderButton from '../../atoms/sliderButton/SliderButton';
import styles from './SwiperWithArrows.module.scss';
import clsx from 'clsx';


const SwiperWithArrows = ({
  children,
  customClasses,
  autoHeightSelector,
  hideLockedArrow,
  type = '',
  ...swiperProps
}) => {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperRef = useRef(null);

  const [prevArrowStyles, setPrevArrowStyles] = useState();
  const [nextArrowStyles, setNextArrowStyles] = useState();

  const calculateCenterOffset = (containerHeight, buttonRef) => ({
    transform: `
      translateY(${(containerHeight - buttonRef.current?.clientHeight) / 2}px)
    `,
  });

  useLayoutEffect(() => {
    if (
      !autoHeightSelector ||
      !swiperRef?.current ||
      !navigationPrevRef?.current ||
      !navigationNextRef?.current
    )
      return;

    const [firstSwiperSlide] = swiperRef.current.swiper.slides;
    const targetHeight = autoHeightSelector(firstSwiperSlide)?.clientHeight;

    if (!targetHeight) {
      console.warn('No node found by selector');
      return;
    }

    setPrevArrowStyles(calculateCenterOffset(targetHeight, navigationPrevRef));
    setNextArrowStyles(calculateCenterOffset(targetHeight, navigationNextRef));
  }, [autoHeightSelector, swiperRef, navigationPrevRef, navigationNextRef]);

  // prevent buttons jumping after position styles changed
  const isPositionPending =
    autoHeightSelector && (!prevArrowStyles || !nextArrowStyles);

  return (
    <Swiper
      ref={swiperRef}
      {...swiperProps}
      navigation={{
        prevEl: navigationPrevRef?.current,
        nextEl: navigationNextRef?.current,
      }}
      modules={[Scrollbar, Autoplay, Navigation]}
    >
      {children}
      <SliderButton
        style={prevArrowStyles}
        direction="left"
        className={clsx(
          styles.arrowNavigationLeft,
          customClasses,
          !prevArrowStyles && styles.defaultPosition,
          isPositionPending && styles.hidden,
          'button-left',
        )}
        innerRef={navigationPrevRef}
        ButtonComponent={type === 'journal' ? ArrowLeftNarrow : ArrowLeft}
      />
      <SliderButton
        style={nextArrowStyles}
        direction="right"
        className={clsx(
          styles.arrowNavigationRight,
          customClasses,
          !nextArrowStyles && styles.defaultPosition,
          isPositionPending && styles.hidden,
          'button-right',
        )}
        innerRef={navigationNextRef}
        ButtonComponent={type === 'journal' ? ArrowRightNarrow : ArrowRight}
      />
    </Swiper>
  );
};

export default SwiperWithArrows;
